import React from "react"

interface Props extends React.ComponentPropsWithoutRef<"svg"> {
    size?: number | string
    style?: React.CSSProperties
    color?: string
    className?: string
}

export function YouTubeFarFAIcon({ size = 16, color, style, className, ...others }: Props) {
    return (
        <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fab"
            data-icon="youtube"
            className={`svg-inline--fa fa-youtube fa-w-10 fa-fw ${className}`}
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 17.0625 12"
            color={color}
            style={{ width: size, height: size, ...style }}
            {...others}
        >
            <path
                fill="currentColor"
                d="M16.7188 1.875C17.0625 3.21875 17.0625 6 17.0625 6C17.0625 6 17.0625 8.8125 16.7188 10.1562C16.5312 10.875 15.9375 11.4375 15.2188 11.6562C13.875 12 8.53125 12 8.53125 12C8.53125 12 3.1875 12 1.875 11.6562C1.125 11.4375 0.5625 10.875 0.34375 10.1562C0 8.8125 0 6 0 6C0 6 0 3.21875 0.34375 1.875C0.5625 1.125 1.125 0.5625 1.875 0.375C3.1875 0 8.53125 0 8.53125 0C8.53125 0 13.875 0 15.1875 0.375C15.9375 0.5625 16.5312 1.125 16.7188 1.875ZM6.78125 8.5625L11.25 6L6.78125 3.46875V8.5625Z"
            />
        </svg>
    )
}
